/**
 * MLB Preset card: table of attribute details (detail_name, detail_group, detail_value).
 */
import React from 'react';
import { Card, Table } from 'react-bootstrap';

/**
 * @param {{ mlbDetails: Array<{ id?: number, detail_name?: string, detail_group?: string, detail_value?: string }> | null }} props
 */
const MlbPresetTable = ({ mlbDetails }) => {
  if (mlbDetails === null) return null;
  return (
    <Card className="mb-3">
      <Card.Header>MLB Preset</Card.Header>
      <Card.Body className="p-0">
        {!mlbDetails?.length ? (
          <p className="text-muted mb-0 p-3">No MLB attribute details for this product.</p>
        ) : (
          <Table className="info-table mb-0" size="sm" responsive>
            <thead>
              <tr>
                <th className="info-table-label">Attribute</th>
                <th className="info-table-label">Group</th>
                <th className="info-table-label">Value</th>
              </tr>
            </thead>
            <tbody>
              {mlbDetails.map((d, idx) => (
                <tr key={d.id ?? idx}>
                  <td className="info-table-value">{d.detail_name ?? '—'}</td>
                  <td className="info-table-value">{d.detail_group ?? '—'}</td>
                  <td className="info-table-value">{d.detail_value ?? '—'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default MlbPresetTable;
